export const getBaseUrl = () => {
    if (window && window.runConfig) {
        const mode = window.runConfig.mode;
        const config = window.runConfig[mode];

        if (config && config.baseURL) {
            return config.baseURL;
        } else {
            console.error('Base URL not found for mode:', mode);
            return '';
        }
    } else {
        console.error('window.runConfig not found');
        return '';
    }
};
